import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Logo } from "@/components/Logo";
import { LocaleSwitcher } from "@/components/LocaleSwitcher";
import { ThemeSwitcher } from "@/components/ThemeSwitcher";

export function HomePage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen page-bg flex flex-col items-center justify-center px-4 py-12">
      <div className="home-surface max-w-2xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <Logo className="h-24 w-auto" />
        </div>
        <div className="space-y-4 text-center">
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground">
            {t("home.title")}
          </h1>
          <p className="text-xl text-muted-foreground leading-relaxed">
            {t("home.subtitle")}
          </p>
        </div>
        <div className="flex flex-col items-center gap-8 pt-6">
          <div className="w-full flex items-start gap-2.5 px-4 py-3 rounded-xl border border-ink-8 bg-ink-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-3.5 h-3.5 text-ink-30 shrink-0 mt-0.5"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4" />
              <path d="M12 8h.01" />
            </svg>
            <p className="text-xs text-ink-40 leading-relaxed text-left">
              {t("home.workplaceNotice")
                .split("Workplace")
                .map((part, index, parts) =>
                  index < parts.length - 1 ? (
                    <span key={index}>
                      {part}
                      <span className="font-semibold text-ink-70 tracking-wide">Workplace</span>
                    </span>
                  ) : (
                    part
                  ),
                )}
            </p>
          </div>
          <Link
            to="/wizard"
            data-testid="button-start-setup"
            className="px-8 py-3 text-base font-medium text-ink rounded-full border border-ink-30 bg-transparent hover:bg-ink-6 hover:border-ink-50 transition-all duration-200 cursor-pointer"
          >
            {t("home.startSetup")}
          </Link>
          <LocaleSwitcher />
          <ThemeSwitcher />
        </div>
      </div>
    </div>
  );
}
